<template>
<div>
    <v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="Career Map"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="display-1 text-center primary--text font-weight-medium mt-8 d-flex justify-center align-center" v-if="loaded">
            <div class="mr-2">TOP UNIVERSITY:</div>
            <v-avatar color="accent" class="white--text">{{item.position}}</v-avatar>
        </div>

        <div class="text-center">
            <v-btn text class="accent--text" @click="$router.push('/map-of-careers/best-universities')">
                <v-icon small color="accent" left>fa-angle-left</v-icon>
                Back to TOP universities
            </v-btn>
        </div> 

        <v-divider class="mt-3 mb-6"></v-divider>

        <v-card outlined v-if="loaded">
            <div class="pa-6 primary">
                <div class="display-1 white--text">{{item.name}}</div>
                <div class="caption font-weight-bold white--text ml-1">POSITION: {{item.position}}</div>
            </div>

            <div class="pa-6">
                <div class="d-flex justify-space-between align-center">
                    <div>
                        <div class="body-2 font-weight-bold primary--text text--darken-1">LOCATED IN</div>
                        <div>{{item.location}}</div>
                    </div>
                    <div>
                        <v-btn fab text @click="showDiagTop=true">
                            <v-icon color="red" v-if="item.hearted">fa-heart</v-icon>
                            <v-icon color="grey" v-else>far fa-heart</v-icon>
                        </v-btn>
                    </div>
                </div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">OVERVIEW</div>
                <div v-html="item.overview"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">POPULAR MAJORS/COLLEGES/SCHOOLS</div>
                <div v-html="item.pmc"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">ANNUAL COST OF ATENDANCE</div>
                <div v-html="item.cost"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">HOW TO APPLY</div>
                <a v-html="item.howTo" target="_blank" :href="item.howTo" class="accent--text"></a>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">UNIVERSITY VALUES</div>
                <div v-html="item.values"></div>
            </div>
        </v-card>

        <SendingLoader v-else />
    </v-card>

    <DiagTopUniv 
        v-if="item!=null"
        :model="showDiagTop" 
        :item="item"
        @cancel="closeDiag"
        @changed="setHeart" />
</div>
</template>

<script>
import _ from 'lodash'
import Sign from '@/firebase/sign'
import Helpers from '@/services/helpers'
import Careers from '@/firebase/careers'
import DiagTopUniv from '@/components/core/dialogs/DiagTopUniv'

export default {
    data: () => ({
        loaded: false,
        item: null,
        showDiagTop: false
    }),
    components: {
        DiagTopUniv
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Careers.getBestUniversity(this.$route.params.id)
                    .then(response => {
                        if (response.status == true) {
                            this.item = response.doc.data();
                            this.item.id = response.doc.id;
                            if (this.user.mytop && this.user.mytop.universities) {
                                this.checkHearted();
                            }
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        closeDiag() {
            this.showDiagTop = false;
        },
        setHeart(e) {
            this.item.hearted = true;
            this.closeDiag();
            Sign.reInitUser(this.user.uid);
        },
        checkHearted() {
            if (this.user.mytop.universities.p1 && this.user.mytop.universities.p1.id == this.item.id)  this.item.hearted = true;
            if (this.user.mytop.universities.p2 && this.user.mytop.universities.p2.id == this.item.id)  this.item.hearted = true;
            if (this.user.mytop.universities.p3 && this.user.mytop.universities.p3.id == this.item.id)  this.item.hearted = true;
        }
    }
}
</script>

<style>
    b {
        font-size:14px;
    }
</style>